import * as React from "react";
import TextareaAutosize from "react-textarea-autosize";

import { cn } from "@src/lib/utils/cn";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  autoSize?: boolean;
  minRows?: number;
  maxRows?: number;
  placeholderClassName?: string;
}

const baseClassName =
  "flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-[14px] tracking-[-0.006em] placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50";

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    { className, placeholderClassName, autoSize, minRows, maxRows, ...props },
    ref,
  ) => {
    const classes = cn(baseClassName, className, placeholderClassName);
    if (autoSize) {
      return (
        <TextareaAutosize
          ref={ref}
          className={classes}
          minRows={minRows}
          maxRows={maxRows}
          {...(props as React.ComponentProps<typeof TextareaAutosize>)}
        />
      );
    }
    return <textarea ref={ref} className={classes} {...props} />;
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
